module.exports = __webpack_public_path__ + "img/swiperImg_earthGlobe.b38d0f6e.png";